import { coreStore as core } from '../modules/Core';
import {
  userStore as user,
  subscriptionStore as subscription,
  clientStore as client,
  personStore as person,
} from '../modules/Person';
import { store as application } from '../modules/Application';
import {
  fiscalComponentsStore as fiscalComponents,
  nfseConfigurationsStore as nfseConfigurations,
  nfseTributesComponentsStore as nfseTributesComponents,
  nfseTributesStore as nfseTributes,
  nfseNaturesStore as nfseNatures,
  nfseStore as nfse,
  nfseComponentsStore as nfseComponents,
  nfeStore as nfe,
  pdvStore as pdv,
  naturezaStore as natureza,
  origemStore as origem,
  cstStore as cst,
  cenqStore as cenq,
  csosnStore as csosn,
  freightStore as freight,
  satStore as sat,
  emissorStore as emissor,
  store as fiscal,
  beneficioStore as beneficio,
  cfopParameterizationsStore as cfopParameterizations,
  ibsRegimeStore as ibsRegime,
  TEFStore as tef,
  stoneStore as stone,
  zposStore as zpos,
} from '../modules/Fiscal';
import {
  purchaseStore as purchase,
  componentsPurchaseStore as componentsPurchase,
  productStore as product,
  paymentStore as payment,
  unitOfMeasureStore as unitOfMeasure,
  creditLimitStore as creditLimit,
  serviceStore as service,
  osSituationsStore as osSituations,
  osIdentifiersStore as osIdentifiers,
  osObjectsStore as osObjects,
} from '../modules/Inventory';
import { accountStore as account, categoryStore as category } from '../modules/Finance';

export default {
  fiscal,
  emissor,
  core,
  user,
  application,
  pdv,
  subscription,
  client,
  nfe,
  purchase,
  componentsPurchase,
  natureza,
  person,
  product,
  payment,
  account,
  category,
  origem,
  cst,
  cenq,
  csosn,
  unitOfMeasure,
  freight,
  sat,
  service,
  nfse,
  nfseTributes,
  nfseNatures,
  nfseTributesComponents,
  nfseConfigurations,
  nfseComponents,
  fiscalComponents,
  creditLimit,
  osSituations,
  osIdentifiers,
  osObjects,
  beneficio,
  cfopParameterizations,
  ibsRegime,
  tef,
  stone,
  zpos,
};
